const Data = [
    {
        id: 1,
        category: "education",
        icon: "fa-solid fa-school",
        year: "2021 - devam",
        title: "Lisans",
        desc: "Necmettin Erbakan Üniversitesi - Bilgisayar Mühendisliği"
    },
    {
        id: 2,
        category: "education",
        icon: "fa-solid fa-school",
        year: "2016 - 2020",
        title: "Lise",
        desc: "MBO Sağlık Meslek Lisesi - Hemşire Yardımcılığı"
    },
    {
        id: 3,
        category: "education",
        icon: "fa-solid fa-school",
        year: "2012 - 2016",
        title: "Ortaokul",
        desc: "Erdem Bayazıt İmam Hatip Ortaokulu"
    },
    {
        id: 3,
        category: "experience",
        icon: "fa-solid fa-briefcase",
        year: "2025 Mart - Halen",
        title: "Aday Mühendis",
        desc: "HAVELSAN"
    },
    {
        id: 4,
        category: "experience",
        icon: "fa-solid fa-briefcase",
        year: "2025 Eylül - Halen",
        title: "Eğitmen",
        desc: "T3 Vakfı - Deneyap Türkiye - Eğitmen"
    },
    {
        id: 5,
        category: "experience",
        icon: "fa-solid fa-briefcase",
        year: "2024 Eylül - 2025 Mart",
        title: "Bilgisayar Müh. Stajyeri",
        desc: "HAVELSAN"
    },
    {
        id: 6,
        category: "experience",
        icon: "fa-solid fa-briefcase",
        year: "2024 Haziran - 2024 Eylül",
        title: "Bilgisayar Müh. Stajyeri",
        desc: "NEÜ - Sağlık, Kültür ve Spor"
    },
    {
        id: 7,
        category: "experience",
        icon: "fa-solid fa-briefcase",
        year: "2024 Nisan - 2024 Haziran",
        title: "Yapay Zeka Eğitmeni",
        desc: "T3 Vakfı - Deneyap Türkiye - Eğitmen"
    },
    {
        id: 8,
        category: "experience",
        icon: "fa-solid fa-briefcase",
        year: "2023 Şubat - 2023 Ağustos",
        title: "Veri Bilimi - Web Programlama",
        desc: "Konya Kapsül Teknoloji Platformu - Gönüllü"
    },
    // {
    //     id:7,
    //     category: "experience",
    //     icon: "fa-solid fa-briefcase",
    //     year: "2019 Eylül - 2020 Mart",
    //     title: "Üroloji ve Dahiliye Servisi",
    //     desc : "Konya Numune Hastanesi - Stajyer"
    // }

]
export default Data;